import { render } from "./EditPlantDashboardHeader.vue?vue&type=template&id=44dfb284"
import script from "./EditPlantDashboardHeader.vue?vue&type=script&lang=js"
export * from "./EditPlantDashboardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__